import {IMuWidget} from "./IMuWidget";
import {AdminTrainingCL} from "./generated/AdminTrainingCL";
import {SearchSelector} from "./SearchSelector";
import {UiFlashMessage} from "./UiFlashMessage";
import * as Sortable from "sortablejs";
import {flashError, flashInfo} from "./Utils";
import {Course, VersionPart} from "./CourseTypes";
import {UiSelect} from "./UiSelect";
import {Htmlarea} from "./Htmlarea";
import {Course as UiCourse} from './Course';
// import Sortable from "sortablejs";

export class TrainingAdmin extends IMuWidget {
	public clUrl: string;

	public cl: AdminTrainingCL;

	public place: string;

	beforeIndex() {
		this.container.innerHTML = `<div mu-id="courseList">
			<div mu-id="preview" mu-widget="Course" mu-params='{"isPreview":true}'></div>
			<h3>Školení pro místo <code mu-id="place"></code></h3>
			<ul mu-id="list">
				<li mu-template="item" mu-widget=".">
					<span class="icon-pack">
						<!-- <span class="icon-remove" title="Úplně odstranit ze všech míst" mu-id="bDelete"></span> -->
						<span class="icon-checked-off" title="Odpojit z tohoto místa" mu-id="bUnlink"></span>
						<span class="icon-book-help" title="Náhled" mu-id="bPreview"></span>
					</span>
					<span mu-bind='name|defaultValue("(bez názvu)")' mu-id="name" class="a"></span>
					<span mu-bind='version|field("name")'></span>
				</li>
			</ul>
			<div class="display-flex gap-4px">
				<span>Připojit existující školení</span>
				<div mu-widget="SearchSelector" mu-id="cAddCourse" class="flex-grow-1"></div>		
				<span class="btn btn-primary" mu-id="bLinkSelected">Připojit vybrané</span>
			</div>
			<div class="display-flex gap-4px">
				<span>Název nového školení</span>
				<input type="text" class="flex-grow-1 form-control" mu-id="cNewName" /> 
				<span class="btn btn-primary" mu-id="bCreateNew">Vytvořit nové školení</span>
			</div>
		</div>
		<div mu-widget="CourseEditor" mu-id="editor" class="form-horizontal" mu-bind="id:.id">
			<h3>Úprava školení</h3>
			<div class="row form-group">
				<label mu-for="bind:name" class="col-md-3 control-label">Název kurzu</label>
				<div class="col-md-9">
					<input type="text" mu-bind="name" class="form-control" />
				</div>
			</div>
			<div class="row form-group">
				<label mu-for="bind:name" class="col-md-3 control-label">Závisí na</label>
				<div class="col-md-9">
					<div mu-widget="SearchSelector" mu-id="cDependOn" mu-bind="dependOn" class="flex-grow-1"></div>
				</div>
			</div>
			<div class="panel">
				<div mu-bind="content" mu-widget="CourseContentEditor" class="course-content-editor">
					<h4>Kapitoly</h4>
					<ol mu-bind="slides::@foreach" mu-id="slides">
						<li mu-widget="CourseContentEditorSlide" mu-template="slide">
							<div class="display-flex gap-4px">
								<span class="icon-up-down handler"></span>
								<span class="icon-remove cursor-pointer" title="Smazat tuto kapitolu" mu-id="bRemove"></span>
								<input mu-bind="name" mu-id="name" class="editable flex-grow-1 " placeholder="Název kapitoly" />
							</div>
							<div mu-id="details">
								<div mu-widget="Htmlarea" mu-bind="content" mu-id="content" mu-params='{"delayedInit":true}'></div>
							</div>
						</li>
					</ol>
					<span class="btn btn-link" mu-id="bAddSlide">Přidat kapitolu</span>
				</div>
				<div class="buttons">
					Uložit jako:
					<span class="btn btn-default" mu-click='bSave_click:"draft"'>Koncept</span>
					<span mu-id="pVersionSaveButtons">
						<span class="btn btn-primary" mu-click='bSave_click:"patch"' title="Uživatel nebude upozorněn">Bezvýznamná změna</span>
						<span class="btn btn-warning" mu-click='bSave_click:"minor"' title="Uživatel bude upozorněn">Malá změna</span>
						<span class="btn btn-danger" mu-click='bSave_click:"major"' title="Uživatel musí znovu projít školením">Velká změna</span>					
					</span>
					<span mu-id="bFirstPublish" class="btn btn-primary" mu-click='bSave_click:"major"'>Uveřejnit</span>
					<span> | </span>
					<span class="btn btn-default" mu-id="bPreview">Náhled</span> 
					<span class="btn btn-danger" mu-id="bClose">Zavřít bez uložení</span> 
				</div>
			</div>
		</div>`;
	}

	muNamedWidget: {
		cAddCourse: SearchSelector,
		editor: CourseEditor,
		preview: UiCourse,
	}

	afterIndex() {
		this.cl = new AdminTrainingCL(this.clUrl);
		this.loadCourses();
		this.muNamedWidget.cAddCourse.searchPromiseCallback = this.courseFulltext;
		this.closeCourse();
	}

	private loadCourses() {
		this.ui.place.innerText = this.place;
		this.ui.list.innerHTML = '';
		return this.cl.withMessage("Načítám školení").getCoursesForPlace(this.place).then(data => {
			for(const course of data)
				this.muWidgetFromTemplate('item', 'list', {
					name_click: () => this.loadCourse(course.id),
					bUnlink_click: () => confirm('Opravdu chcete odpojit kurz ' + course.name) ? this.unlinkCourse(course.id) : undefined,
					bPreview_click: () => {
						// const slides = await this.cl.getCourse(co);
						this.muNamedWidget.preview.preview(course.content.slides);
					}
				}).muBindData(course);
		});
	}

	bLinkSelected_click() {
		this.cl.withMessage("Připojuji kurzy").addCoursesToPlace(
			this.muNamedWidget.cAddCourse.muFetchData().map(idStr => parseInt(idStr)),
			this.place
		).then(() => {
			UiFlashMessage.instance.add('Kurzy byly přiřazeny na toto místo.');
			this.muNamedWidget.cAddCourse.muBindData([]);
			this.loadCourses();
		});
	}

	public courseFulltext = (fulltext: string|string[]|number[]) => this.cl.withMessage("Hledám školení").searchCourse(fulltext);

	private loadCourse(id: number) {
		this.cl.withMessage('Načítám školení').getCourseDetail(id)
			.then(course => {
				this.muNamedWidget.editor.muBindData(course);
				this.muVisible(true, 'editor');
			});
	}

	private closeCourse() {
		this.muVisible(false, 'editor');
	}

	private unlinkCourse(id: number) {
		this.cl.withMessage("Odpojuji kurzy").removeCoursesFromPlace(
			[ id ],
			this.place
		).then(() => {
			UiFlashMessage.instance.add('Kurzy byly odpojeny.');
			this.loadCourses();
		});
	}

	bCreateNew_click() {
		const newName = this.ui.cNewName.value.trim();
		if (newName == "") flashError("Musí být zadán název");
		else this.cl.withMessage("Vytvářím školení").newCourse(newName, this.place).then((res) => {
			if (res.success)
			{
				this.loadCourses();
				this.loadCourse(res.data.courseId);
				flashInfo("Nové školení " + newName + " bylo vytvořeno");
			}
			else flashError(res.message);
		} );
	}

	editor_saved() {
		this.closeCourse();
		this.loadCourses();
	}
}

export class CourseEditor extends IMuWidget {
	public id: number;
	muParent: TrainingAdmin;
	public course: Course;

	afterIndex() {
		this.muRegisterEvent('saved');
		(this.muNamedWidget.cDependOn as SearchSelector).searchPromiseCallback = this.muParent.courseFulltext;
		// (this.muNamedWidget.cDependOn as UiSelect).searchCallback = this.muParent.courseFulltext;
	}

	muBindData(srcData: any) {
		this.id = srcData.id;
		this.course = srcData;
		super.muBindData(srcData);
		this.muVisible(!!srcData.version.major, [
			'!bFirstPublish',
			'pVersionSaveButtons'
		])
	}

	bSave_click(ev: Event, target: VersionPart|"draft") {
		this.muParent.cl.withMessage("Ukládám školení").saveCourse(
			this.id,
			this.muFetchData(),
			target === "draft",
			target === "draft" ? null : target
		).then(res => {
			if (res.success) {
				flashInfo(res.message || "Uloženo");
				this.muDispatchEvent('saved');
			} else flashError(res.message)
		});
	}

	bPreview_click() {
		this.muParent.muNamedWidget.preview.preview(this.muFetchData().content.slides);
	}
}

export class CourseContentEditor extends IMuWidget {
	private slideSortable: any;
	bAddSlide_click() {
		this.muWidgetFromTemplate('slide', 'slides');
	}
	afterIndex() {
		this.setupSlidesDraggable();
	}

	private setupSlidesDraggable() {
		this.slideSortable = Sortable.default.create(
			this.ui.slides,
			{
				handle: ".handler"
			}
		);
	}
}

export class CourseContentEditorSlide extends IMuWidget {
	afterIndex() {
		(this.muNamedWidget.content as Htmlarea).uploadUrl = (this.muParent?.muParent as CourseEditor).course.ckeUploadUrl;
	}

	bRemove_click() {
		if (confirm('Odstranit kapitolu "' + this.ui.name.value + "'?")) this.muRemoveSelf();
	}
}